import { basicValidation } from '../basicValidation';

const fieldValidation = {
    id: (value: string) => basicValidation.resourceId.isValid(value),
};

export const uploadSlotFieldValidation = {
    uploadSlot: fieldValidation
};
